// extracted by mini-css-extract-plugin
export default {"btnContainer":"BtnContainer_btnContainer__HJJ0m"};